export default {
  data() {
    return {
      childrenDisplayed: false,
      timeoutId: null,
    };
  },
  methods: {
    showChildren() {
      // clearTimeout(this.timeoutId);
      // this.timeoutId = setTimeout(() => { this.childrenDisplayed = true; }, 100);
      this.childrenDisplayed = true;
    },
    hideChildren() {
      this.childrenDisplayed = false;
    },
  },
};
